/*!
 * jQuery icon view plugin
 * Original author: Claude Deschênes
 * Licensed PRIVATE
 * Autorisation required
 */


import init_data from './iconsView-data';
import init_utils from './iconsView-utils';
import init_menu from './iconsView-menu';
import init_toolbar from './iconsView-toolbar';
import init_render from './iconsView-render';
import init_actions from './iconsView-actions';
import init_core from './iconsView-core';
import {
    BaseView,
    CardView,
    CardsView,
    TableView,
    TreeView,
    BlocksView,
    MosaicView,
    IconsViewMode,
    ListView,
    ThumbnailsView,
    SlideshowView,
    SummaryView,
    PreviewView,
    CalendarView,
    KanbanView,
    TimelineView,
    MapView,
    CheatsheetView,
    AccordionView,
    registerView,
    createViewInstance,
    viewRegistry,
} from './views';

const iconsViewCache = {};
let firstGrid = null;

global.iconViewDefault = {
    propertyName: 'value',
};

// Expose views and registry on constructor
IconsView.BaseView = BaseView;
IconsView.CardView = CardView;
IconsView.CardsView = CardsView;
IconsView.TableView = TableView;
IconsView.TreeView = TreeView;
IconsView.AccordionView = AccordionView;
IconsView.BlocksView = BlocksView;
IconsView.MosaicView = MosaicView;
IconsView.IconsViewMode = IconsViewMode;
IconsView.ListView = ListView;
IconsView.ThumbnailsView = ThumbnailsView;
IconsView.SlideshowView = SlideshowView;
IconsView.SummaryView = SummaryView;
IconsView.PreviewView = PreviewView;
IconsView.CalendarView = CalendarView;
IconsView.KanbanView = KanbanView;
IconsView.TimelineView = TimelineView;
IconsView.MapView = MapView;
IconsView.CheatsheetView = CheatsheetView;
IconsView.registerView = registerView;
IconsView.createViewInstance = createViewInstance;
IconsView.viewRegistry = viewRegistry;

// The actual plugin constructor
function IconsView(element, options) {
    this.element = $(element);
    this.uid = this.element.attr('id');
    this.name = this.element.attr('name');
    this.value = this.element.data('value');
    this.valueType = this.element.data('value-type');
    this.parent = this.element.data('parent');
    this.parentType = this.element.data('parent-type');
    this.cookieName = 'CURRENT_VIEW_PATH' + ((this.name) ? '_' + this.name.toUpperCase() : '')
    this.container = null;
    this.containerView = null;
    this.firstLoad = true;
    this.reloadInput = false;
    this.isLoading = false;
    this.isLoadingDeep = 0;
    this.isBusy = false;
    this.timerBusy = 0;
    this.go = [];
    this.selection = [];
    this.selectionInput = null;
    this.selectionInputType = null;
    this.selectionInputLabel = null;
    this.rootId = null;
    this.rootType = null;
    this.data = [];
    this.dataMode = 'empty';
    this.dataClean = [];
    this.dataJsonCache = null;
    this.dataNode = null;
    this.dataNodeParent = null;
    this.dataField = null;
    this.options = {};
    this.actions = {};
    this.templates = [];
    this.types = [];
    this.template = null;
    this.templateName = 'default';
    this.view = null;
    this.viewLock = false;
    this.viewThumbsWidth = null;
    this.viewThumbsHeight = null;
    this.viewThumbsProportions = 1;
    this.viewItemWidthRatio = 1;
    this.viewItemWidthMin = 0;
    this.viewItemWidthMax = 500;
    this.viewItemThumbsMode = false;
    this.fixedSize = {};
    this.fixedView = {};
    this.fixedSort = {};
    this.fixedTab = {};
    this.modes = this.element.data('modes') || this.element.data('views') || (options && (options.modes || options.views || options.allowedModes || options.allowedViews)) || null;
    if (typeof this.modes === 'string') {
        try {
            const parsed = JSON.parse(this.modes);
            if (Array.isArray(parsed)) this.modes = parsed;
            else this.modes = this.modes.split(',').map(m => m.trim()).filter(Boolean);
        } catch (e) {
            this.modes = this.modes.split(',').map(m => m.trim()).filter(Boolean);
        }
    }
    this.order = null;
    this.orderType = null;
    this.path = [];
    this.pathValid = [];
    this.selectionLast = null;
    this.dataExpand = [];
    this.filters = {};
    this.events = {
        error(data) {
        },
    }
    this.scrollLast = 0;
    this.clsBarBot = (this.element.data('cls-bot')) ? this.element.data('cls-bot') : '';
    this.clsBarTop = (this.element.data('cls-top')) ? this.element.data('cls-top') : '';
    this.timerLastLoad = 0;
    this.timerLastLoadfull = 0;
    this.cache = this.element.data('cache');
    this.cachePng = {};
    this.request = null;
    this.tabMode = null;
    this.lockActions = false;
    this.globalMenu = {}
    this.cursor = '';
    this.cursorLast = '';

    this.date = new Date();

    this.listTrigger = ['action', 'select', 'selectInt', 'select1', 'menu'];

    // add class
    this.element.addClass('iv');

    if (this.value) {
        this.selection = [{
            id: this.value,
            type: this.valueType,
        }]
    }

    if (this.element.data('go')) {
        this.go = [{
            id: this.element.data('go'),
            type: this.element.data('goType'),
        }]
    }

    // jQuery has an extend method that merges the
    // contents of two or more objects, storing the
    // result in the first object. The first object
    // is generally empty because we don't want to alter
    // the default options for future instances of the plugin
    this.conf = $.extend({}, global.iconViewDefault, options);

    this._defaults = global.iconViewDefault;
    this._name = 'iconsView';

    this.init();

    const myself = this;
    const resizeNamespace = 'resize.iv_' + (this.uid || this.name || Math.floor(Math.random() * 1000000));
    this._resizeNamespace = resizeNamespace;
    let resizeTimer = null;
    $(window).off(resizeNamespace).on(resizeNamespace, () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            myself.resize();
        }, 150);
    });

    this.timerInterval = setInterval(() => {
        myself.timer();
    }, 1000);
}

init_data(IconsView, iconsViewCache);
init_utils(IconsView, iconsViewCache);
init_menu(IconsView, iconsViewCache);
init_toolbar(IconsView, iconsViewCache);
init_render(IconsView, iconsViewCache);
init_actions(IconsView, iconsViewCache);
init_core(IconsView, iconsViewCache);


;(function ($, window, document, undefined) {
    // undefined is used here as the undefined global
    // variable in ECMAScript 3 and is mutable (i.e. it can
    // be changed by someone else). undefined isn't really
    // being passed in so we can ensure that its value is
    // truly undefined. In ES5, undefined can no longer be
    // modified.

    // window and document are passed through as local
    // variables rather than as globals, because this (slightly)
    // quickens the resolution process and can be more
    // efficiently minified (especially when both are
    // regularly referenced in your plugin).

    // Create the defaults once
    const pluginName = 'iconsView';


    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function (a, b) {
        let action;
        let options;
        if (typeof a === 'string') {
            action = a;
            options = b;
        } else {
            action = 'init';
            options = a;
        }

        return this.each(function () {
            if ($(this).data('plugin')) {
                return $(this).data('plugin');
            }
            let inst = $.data(this, 'plugin_' + pluginName);
            if (!inst) {
                $.data(this, 'plugin_' + pluginName, new IconsView(this, options));
            } else if (action === 'destroy') {
                if (typeof inst.destroy === 'function') {
                    inst.destroy();
                }
                $.removeData(this, 'plugin_' + pluginName);
            } else {
                inst.action(action, options);
            }
        });
    };
}(jQuery, window, document));

export default IconsView;


